import { createStore } from '@stencil/store';
import { collectionData } from 'rxfire/firestore';
import { collection, orderBy, query } from 'firebase/firestore';
import { EMPTY, Subscription, catchError } from 'rxjs';
import { settings } from './settings.store';
import { FirebaseService } from '../utils/firebase';
import { CustomField } from '@artask/tambr-models/models/custom-field.model';


interface CustomerFieldsState {
  customerFieldsLoading: boolean;
  customerFieldsLoaded: boolean;
  
  customFields: CustomField[];
  customFieldsSubscription: Subscription;
}

const { state, reset, onChange } = createStore<CustomerFieldsState>({
  customerFieldsLoading: false,
  customerFieldsLoaded: false,
  
  customFields: [],
  customFieldsSubscription: null,
});

function startCustomerFieldsListener() {
  state.customerFieldsLoading = true;

  const ref = collection( FirebaseService.firestore, `businesses/${ settings.businessId }/settings/custom-fields/customer` );

  state.customFieldsSubscription = collectionData( 
    query( ref, orderBy('order', 'asc') ), { idField: 'id' } 
  ).pipe(
    catchError( error => {
      console.error( 'Error fetching custom fields:', error );
      state.customerFieldsLoading = false;
      return EMPTY;
    })
  ).subscribe( (customFields: CustomField[]) => {
    state.customFields = customFields;
    state.customerFieldsLoaded = true;
    state.customerFieldsLoading = false;
  });

}

function stopCustomerFieldsListener() {
  if ( state.customFieldsSubscription ) state.customFieldsSubscription.unsubscribe();
  reset();
}

export { 
  state as customerFields, 
  startCustomerFieldsListener, 
  stopCustomerFieldsListener,
  onChange as onCustomerFieldsChange
};